import { useState, useEffect } from "react";
import Leaflet, { Icon } from "leaflet";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import { AddMarkers } from "./AddMarkers";
import { useGameContext } from "../context/useGameContext";
import pinIconUrl from "../assets/logo/marker-pin.svg";
import "leaflet/dist/leaflet.css";

export const WorldMap = () => {
  const { markers, setMarkers, deleteLastMarker } = useGameContext();
  const [mapKey] = useState(Date.now());
  const [mapCenter, setMapCenter] = useState({
    lat: 29.360816,
    lng: -29.683553,
  });
  const [zoom, setZoom] = useState(2);
  const [isMapOpen, setIsMapOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const mapStyle = {
    width: "60vw",
    height: "60vh",
    borderRadius: "10px",
  };

  const corner1 = Leaflet.latLng(-90, -200);
  const corner2 = Leaflet.latLng(90, 200);
  const bounds = Leaflet.latLngBounds(corner1, corner2);

  const mapIcon = require("../assets/icons/icon-world-map.png");

  const customIcon = new Icon({
    iconUrl: pinIconUrl,
    iconSize: [36, 48],
    iconAnchor: [18, 48],
  });

  const toggleMap = () => {
    setIsMapOpen(!isMapOpen);
  };

  return (
    <div className={isMapOpen ? "world" : "world animated"}>
      <div>
        <div>
          {isMapOpen ? (
            <>
              <MapContainer
                center={mapCenter}
                zoom={zoom}
                maxZoom={19}
                minZoom={2}
                bounceAtZoomLimits={false}
                scrollWheelZoom={true}
                style={mapStyle}
                key={mapKey}
                maxBoundsViscosity={1.0}
                maxBounds={bounds}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <AddMarkers setMapCenter={setMapCenter} setZoom={setZoom} />
                {markers.map((marker, index) => (
                  <Marker
                    key={index}
                    position={{ lat: marker.lat, lng: marker.lng }}
                    icon={customIcon}
                    draggable={isMobile}
                    eventHandlers={
                      isMobile
                        ? {
                            dragend: (e) => {
                              const { lat, lng } = e.target.getLatLng();
                              const updatedMarkers = [...markers];
                              updatedMarkers[index] = {
                                ...updatedMarkers[index],
                                lat,
                                lng,
                              };
                              setMarkers(updatedMarkers);
                            },
                          }
                        : undefined
                    }
                  />
                ))}
              </MapContainer>
              <div className="buttons-on-map ">
                <button
                  className={`button is-warning is-focused button-revert-marker `}
                  onClick={deleteLastMarker}
                  disabled={markers.length < 0}
                >
                  Cofnij znacznik
                </button>
                <button
                  className="button is-info is-focused button-minimalize-map"
                  onClick={toggleMap}
                >
                  <span>Zminilizuj mapę</span>
                </button>
              </div>
            </>
          ) : (
            <div className="div-with-map-icon">
              <div className="button-map-close" onClick={toggleMap}>
                <img
                  src={mapIcon}
                  alt="world map"
                  className="button-map-close-icon"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
